import { Behavior } from "../../base/Behavior";
import { ToolsTableCell } from "./ToolsTableCell";
import { TableRow } from "./TableRow";
import { TableRowMode } from "./TableRowMode";

export class TableRowBehavior extends Behavior {
    protected constructor() {
        super();
    }

    allowsEdit(tableRow: TableRow, rowAllowsEdit: boolean): boolean {
        if (tableRow.mode === TableRowMode.QUICK_ADD)
            return true;
        return rowAllowsEdit !== false && tableRow.table.allowEdit === true;
    }

    manageEditStateOnModeChange(tableRow: TableRow, newMode: TableRowMode): void {
        if (newMode !== TableRowMode.SEARCH) {
            this.setCellsPrintable(tableRow, tableRow.rowIsPrintable())
        } else {
            this.setCellsPrintable(tableRow, false);
        }
    }

    private setCellsPrintable(tableRow: TableRow, printable: boolean) {
        if (tableRow.table.printableToggleEnabled) {
            for (const cell of tableRow.cells) {
                if (cell.printableToggleEnabled) {
                    cell.printable = printable;
                }
            }
        }
    }

    addToolsCellToRow(row: TableRow, cell: ToolsTableCell, index: number = -1): void {
        if (cell != null) {
            row._addCellToDOM(cell, index);
        }
    }

    get type(): string {
        return "TableRow";
    }
}

TableRowBehavior.register();
